
(function () {

    if ($(".testimonials-slider-2").length > 0) {
        $(".testimonials-slider-2").slick({
            infinite: false,
            slidesToShow: 1,
            draggable: false,
            vertical: false,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 2000,
        });
    }

    $('.builder-element__3columns--upload [data-file]').css('cursor', 'pointer');
    $('.builder-element__3columns--upload [data-file]').on('click', function () {
        document.location = $(this).data('file');
    });
}());
